import PluginMask from '@vueform/plugin-mask';
import { defineConfig } from '@vueform/vueform';
import theme from '@vueform/vueform/dist/tailwind';
import nlVf from '@vueform/vueform/locales/nl';
import { merge } from 'lodash';

import nlCustom from './src/i18n/nl-NL.json';
import { characterLimitRule } from './src/utils/vueformrules';

// Improved translations. See https://vueform.com/docs/i18n and node_modules/@vueform/vueform/locales/nl/index.mjs
// Do not forget to add the new translations to the i18n/nl-NL.json file when using new validations.
const nl = merge({}, nlVf, nlCustom.message.vueforms);

export default defineConfig({
  theme,
  locales: { nl },
  locale: 'nl',
  plugins: [PluginMask],
  rules: {
    characterLimit: characterLimitRule,
  },
});
